export default __webpack_public_path__ + "static/media/car.21261b03.svg";